export const experience = [
  {
    company: "Prodigy InfoTech",
    designation: "Web Development Trainee",
    location: "Remote",
    duration: "Oct - 2023 - Nov - 2023",
    description: `I used ReactJS, TailwindCSS, HTML, CSS, and JavaScript in real-world web projects, managed codebase with Git, and gained hands-on experience in front-end technologies.`,
  },
  {
    company: "Persistent Systems",
    designation: "Intern",
    location: "Remote",
    duration: "Jul - 2023 - Aug - 2023",
    description: `I immersed in Linux systems, mastering command line intricacies. Applied diverse data structures and gained hands-on experience with Database Management Systems.`,
  },
  {
    company: "Oriental Institute of Science and Technology",
    designation: "B.Tech",
    location: "Information Technology",
    duration: "Oct - 2020 - Present",
    description:
      "Currently pursuing B.Tech in Information Technology from Oriental Institute of Science and Technology, Bhopal.",
  },
];
